import type { FactoryRun } from '@/lib/types';

// MOCK DATA — not from Firestore. Rendered when firebase is unconfigured or
// subscriptions error out, so the scaffold UI remains browsable.
const now = Date.now();

export const MOCK_RUNS: FactoryRun[] = [
  {
    id: 'run_mock_pinned_1',
    status: 'awaiting_oracle_approval',
    currentStage: 'oracle',
    customerId: 'acme-coffee-2026-05',
    customerName: 'Acme Coffee Roasters',
    userEmail: 'owner@acmecoffee.ca',
    createdAtMs: now - 1000 * 60 * 60 * 3,
    updatedAtMs: now - 1000 * 60 * 12,
    lastMessageSnippet:
      'Oracle: feasibility check complete. 3 APIs green, 1 amber. Cost estimate $142/mo. Needs founder sign-off before Logos.',
    unreadForFounder: true,
    awaitingApproval: true,
  },
  {
    id: 'run_mock_pinned_2',
    status: 'awaiting_logos_approval',
    currentStage: 'logos',
    customerId: 'mapleleaf-plumbing',
    customerName: 'Maple Leaf Plumbing',
    userEmail: 'dispatch@mapleleafplumbing.com',
    createdAtMs: now - 1000 * 60 * 60 * 8,
    updatedAtMs: now - 1000 * 60 * 45,
    lastMessageSnippet:
      'Logos: deployment spec drafted — 3 Cloud Run services, 2 Firestore collections, 1 PubSub topic. Ready for review.',
    unreadForFounder: true,
    awaitingApproval: true,
  },
  {
    id: 'run_mock_active_1',
    status: 'discovery',
    currentStage: 'discovery',
    customerId: 'quicklube-east',
    customerName: 'Quick Lube East',
    userEmail: 'manager@quicklubeeast.ca',
    createdAtMs: now - 1000 * 60 * 50,
    updatedAtMs: now - 1000 * 60 * 4,
    lastMessageSnippet:
      "Discovery: Got it — we'll focus on shift scheduling and oil-change inventory.",
    unreadForFounder: false,
  },
  {
    id: 'run_mock_active_2',
    status: 'running',
    currentStage: 'genesis',
    customerId: 'northside-dental',
    customerName: 'Northside Dental',
    userEmail: 'admin@northsidedental.ca',
    createdAtMs: now - 1000 * 60 * 60 * 26,
    updatedAtMs: now - 1000 * 60 * 20,
    lastMessageSnippet: 'Genesis: generating Terraform — 4/11 modules emitted.',
    unreadForFounder: false,
  },
  {
    id: 'run_mock_active_3',
    status: 'paused',
    currentStage: 'oracle',
    customerId: 'greencart-market',
    customerName: 'Greencart Market',
    userEmail: 'owner@greencartmarket.ca',
    createdAtMs: now - 1000 * 60 * 60 * 48,
    updatedAtMs: now - 1000 * 60 * 60 * 6,
    lastMessageSnippet:
      'Run paused by founder — waiting on customer clarification about POS integration.',
    unreadForFounder: false,
  },
  {
    id: 'run_mock_archived_1',
    status: 'archived',
    currentStage: 'discovery',
    customerId: 'oldtown-barber',
    customerName: 'Old Town Barbershop',
    userEmail: 'hello@oldtownbarber.ca',
    createdAtMs: now - 1000 * 60 * 60 * 24 * 5,
    updatedAtMs: now - 1000 * 60 * 60 * 24 * 3,
    lastMessageSnippet:
      'Run archived — customer decided to defer until Q3.',
    unreadForFounder: false,
  },
];
